<script setup lang="ts">
import type { PartialCaptureDecision } from '@/types/carts-transactions-api';

defineProps<{
  isProcessingDecision: boolean;
  confirmedItemsTotal: number;
}>();

const emit = defineEmits<{
  decide: [decision: PartialCaptureDecision];
}>();
</script>

<template>
  <div class="payment-container partial-failure-actions">
    <button type="button" class="cancel-button" :disabled="isProcessingDecision" @click="emit('decide', 'CANCEL_ALL')">
      <svg
        v-if="isProcessingDecision" class="yb-spinner" width="20" height="20" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" opacity="0.3" />
        <path d="M12 2C6.47715 2 2 6.47715 2 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
      {{ $t('cart.partialFailure.cancel') }}
    </button>
    <button type="button" class="confirm-partial-button" :disabled="isProcessingDecision" @click="emit('decide', 'PARTIAL_CAPTURE')">
      {{ $t('cart.partialFailure.confirmPartial', { price: confirmedItemsTotal }) }}
    </button>
  </div>
</template>

<style scoped lang="css">
.payment-container {
  position: sticky;
  bottom: 0;
  padding: var(--yb-spacing-base) 0;
  background: white;
  border-top: var(--yb-color-mediumgray) solid 1px;
}

@media screen and (width < 1024px) {
  .payment-container {
    padding: var(--yb-spacing-base);
  }
}

.partial-failure-actions {
  display: flex;
  flex-direction: column;
  gap: var(--yb-spacing-sm);
}

.cancel-button,
.confirm-partial-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--yb-spacing-xs);
  width: 100%;
  height: 56px;
  padding: var(--yb-spacing-sm);
  border-radius: var(--yb-radius-sm);
  cursor: pointer;
  font-size: var(--yb-text-base);
  font-weight: var(--yb-text-semi-bold);

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &:active:not(:disabled) {
    opacity: 0.9;
  }
}

.cancel-button {
  color: white;
  background-color: var(--yb-color-primary);
  border: none;
}

.confirm-partial-button {
  color: var(--yb-color-black);
  background-color: white;
  border: var(--yb-color-black) solid 2px;
}
</style>
